export default __webpack_public_path__ + "static/media/Version (2) - Prisoner of Azkaban_09.ede4278b.jpg";